import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'
import AssignmentIcon from 'housecall-ui/dist/IconsAndImages/Icons/AssignmentInd'
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography'

const styles = () => ({
  iconWrapper: {
    padding: 8,
  },
  buttonWrapper: {
    padding: 8,
  },
})

const AddEmployeeButton = ({ classes, disabled, onClick, label }) => {
  return (
    <React.Fragment>
      <div className={classes.iconWrapper}>
        <AssignmentIcon className={classes.buttonText} />
      </div>
      <div className={classes.buttonWrapper}>
        <Button
          className={classes.button}
          size="small"
          disabled={disabled}
          onClick={onClick}
        >
          <Typography variant="body1" className={classes.buttonText} noWrap>
            {label}
          </Typography>
        </Button>
      </div>
    </React.Fragment>
  )
}

AddEmployeeButton.defaultProps = {
  label: 'Add employee',
}

AddEmployeeButton.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
}

export default compose(withStyles(styles), memo)(AddEmployeeButton)
